import { Button } from '../../design'
import { AI_CREDENTIALS_COPY } from './aiCredentialsCopy'

export interface CredentialsFormFooterProps {
  pending: boolean
  error: string | null
  onCancel?: () => void
}

export const CredentialsFormFooter = ({ pending, error, onCancel }: CredentialsFormFooterProps) => (
  <>
    {error === null ? null : (
      <p className="settings-error text-tone tone-danger" role="alert">
        {error}
      </p>
    )}
    <div className="ai-credentials-actions">
      <Button type="submit" variant="primary" pending={pending} pendingLabel={AI_CREDENTIALS_COPY.saving}>
        {AI_CREDENTIALS_COPY.save}
      </Button>
      {onCancel === undefined ? null : <Button onClick={onCancel}>{AI_CREDENTIALS_COPY.cancel}</Button>}
    </div>
  </>
)
